export default {

	init() {
		/*eslint-disable no-unused-vars*/
		/*eslint-disable no-undef*/
		/*eslint-disable comma-dangle*/
		/** Maps **/
		function init_map() {
			let selectorMapElement = document.getElementById('map')
			let googleMapTitle = "The Nineteenth is located at Wollongong Golf Club"
			let googleMapAddress = "151-161 Corrimal St, <br> Wollongong NSW 2500"
			let googleMapLat = google_map.coordinates.lat
			let googleMapLng = google_map.coordinates.lng
			let googleMapMarker = google_map.google_map_marker
			let googleMapStyle = [
				{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [{
						"color": "#444444"
					}]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "labels",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "labels.text",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "labels.text.fill",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "geometry.stroke",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [{
						"color": "#f2f2f2"
					}]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [{
						"visibility": "on"
					}]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry.stroke",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "landscape",
					"elementType": "labels.text",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "road",
					"elementType": "all",
					"stylers": [{
							"saturation": -100
						},
						{
							"lightness": 45
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [{
						"visibility": "simplified"
					}]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry.fill",
					"stylers": [{
						"visibility": "on"
					}]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry.stroke",
					"stylers": [{
						"visibility": "on"
					}]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text",
					"stylers": [{
						"visibility": "on"
					}]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [{
						"visibility": "off"
					}]
				},
				{
					"featureType": "water",
					"elementType": "all",
					"stylers": [{
							"color": "#46bcec"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry.fill",
					"stylers": [{
							"visibility": "on"
						},
						{
							"color": "#88d7f7"
						}
					]
				}
			]
			//map options
			let myOptions = {
				zoom: 16,
				center: new google.maps.LatLng(googleMapLat, googleMapLng),
				styles: googleMapStyle,
			}
			//info window
			let infowindow = new google.maps.InfoWindow({
				content: `
				<div class="map__window">
				  <strong>${googleMapTitle}</strong>
				  <div class="map__row">
				  	  <img src="@asset('images/svg/pindrop-isolated.svg')" alt="" />
					  <div class="map__row__address">
					  	<p>${googleMapAddress}</p>
					  	<a target="_blank" href="https://maps.google.com/?saddr=Current+Location&daddr=${googleMapLat},${googleMapLng}">GET DIRECTIONS</a>
					  </div>
				  </div>
				</div>
				`
			})
			//init
			let map = new google.maps.Map(selectorMapElement, myOptions)
			//marker
			let marker = new google.maps.Marker({
				map: map,
				position: new google.maps.LatLng(googleMapLat, googleMapLng),
				icon: googleMapMarker
			})
			//remove parent to set bg colour
			google.maps.event.addListenerOnce(map, 'idle', function() {
				jQuery('.gm-style-iw').prev('div').remove()
			})
			infowindow.open(map, marker)
			// google.maps.event.addListener(marker, 'click', function() {
			//     infowindow.open(map, marker)
			// })
		}
		//init
		google.maps.event.addDomListener(window, 'load', init_map)

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS

	},
}



// WEBPACK FOOTER //
// ./scripts/routes/contact.js